import React from 'react';

/**
 * WithActions
 *
 * @param children
 * @returns {Element}
 * @constructor
 */
export function WithActions({ children }) {
  return <div className="hasActions">{children}</div>;
}
